import { defaultDateTimeFormatter, TableField } from "../../../table-field";

const id: TableField = {
    key: "id",
    label: "Id",
    tdClass: ["align-middle", "d-none"],
    thClass: ["text-center", "naoQuebrar", "d-none"],
    sortable: false
};
const dhAvaliacao: TableField = {
    key: "dhAvaliacao",
    label: "Data da Avaliação",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
    formatter: defaultDateTimeFormatter,
};
const tipo: TableField = {
    key: "tipo",
    label: "Tipo",
    tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const metricaAno = {
    key: "metricaAno",
    label: "Ano",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const metricaDescricao = {
    key: "metricaDs",
    label: "Métrica",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const avTotal = {
    key: "qtdTotal",
    label: "Qtd Total",
    tdClass: ["align-middle", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const avFinalizada = {
    key: "qtdFinalizada",
    label: "Qtd Finalizada",
    tdClass: ["align-middle", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const avErro = {
    key: "qtdErro",
    label: "Qtd Erro",
    tdClass: ["align-middle", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const publico = {
    key: "publico",
    label: "Público",
    tdClass: ["align-middle", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
export const avaliacoes: TableField = {
  key: "avaliacoes",
  label: "Ver Avaliações",
  tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

export const actions: TableField = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions", "naoQuebrar", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};


export const fieldsAvaliacoesGerais: TableField[] = [
    id,
    avaliacoes,
    dhAvaliacao,
    tipo,
    metricaDescricao,
    metricaAno,
    avTotal,
    avFinalizada,
    avErro,
    publico,
    actions
];
